module.exports = __webpack_public_path__ + "img/flat-user-icon2.33513b88.jpg";